import type { DebugSpawnSource } from '~/game/actions';
import { UserInternal, UserRole } from '~/server/src/dtos';
import { resolveEffectiveDebugSpawnSource } from '~/setup/debugSpawnStorage';

import { hasActivePremiumAccess } from './subscriptionAccess';

export { resolveEffectiveDebugSpawnSource } from '~/setup/debugSpawnStorage';

export type PremiumBlockedReason =
  | 'free_subscription_required'
  | 'tournament_subscription_required';

const ADMIN_FREE_DEBUG_SPAWN_SOURCES: ReadonlySet<DebugSpawnSource> = new Set([
  'snapshot',
  'common',
]);

/** Admin may load debug snapshot spawns in free mode without premium (not normal free-game entry). */
export const canAdminBypassFreeSnapshotGate = (
  account?: UserInternal,
  debugSpawnSource?: DebugSpawnSource | null,
): boolean =>
  account?.role === UserRole.Admin &&
  debugSpawnSource != null &&
  ADMIN_FREE_DEBUG_SPAWN_SOURCES.has(debugSpawnSource);

export const requiresPremiumForOnlineMode = (
  mode: 'free' | 'tournament',
  account?: UserInternal,
  debugSpawnSource?: DebugSpawnSource | null,
  userScopeId?: string,
): boolean => {
  if (hasActivePremiumAccess(account)) return false;
  const effectiveSpawnSource = resolveEffectiveDebugSpawnSource(
    debugSpawnSource,
    userScopeId ?? account?.userId,
  );
  if (mode === 'free' && canAdminBypassFreeSnapshotGate(account, effectiveSpawnSource)) {
    return false;
  }
  return true;
};

export const isPremiumBlockedSearch = (
  value: unknown,
): value is PremiumBlockedReason =>
  value === 'free_subscription_required' || value === 'tournament_subscription_required';
